"use client";

import { LanguageProvider } from "@/components/marketing/LanguageContext";
import { Responsive } from "@/components/marketing/viewport";
import { ComingSoonBarDesktop, ComingSoonBarMobile } from "./ComingSoonBar";
import { HeroSectionDesktop, HeroSectionMobile } from "./HeroSection";
import EarlyAccess from "./EarlyAccess";
import ComingSoonDesktop from "./ComingSoonDesktop";
import ComingSoonMobile from "./ComingSoonMobile";

export default function Home02Page() {
  return (
    <LanguageProvider>
      <div className="marketing-shell w-full min-h-screen flex flex-col overflow-x-clip font-['Outfit'] relative">
        <ComingSoonBarMobile />
        <ComingSoonBarDesktop />
        <Responsive mobile={<HeroSectionMobile />} desktop={<HeroSectionDesktop />} />
        <Responsive mobile={<EarlyAccess mobile />} desktop={<EarlyAccess />} />
        <Responsive mobile={<ComingSoonMobile />} desktop={<ComingSoonDesktop />} />
      </div>
    </LanguageProvider>
  );
}
